import React from 'react';
import { getAppEnv } from '../../../../config/env';

import '../../../styles/PnrAppDownloadSection.css';
import { PNR_APP_DOWNLOAD_SECTION_CONSTANTS } from '../constants/PnrSeoConstants';

const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

const onAppDownloadClick = () => {
  window.open('https://app.mmyt.co/Xm2V/appinstalltrainslanding', '_blank');
};

interface AppStoreData {
  data: {
    heading: string;
    rating: number;
    reviewCountText: string;
  };
}

export default function PnrAppDownloadSection() {
  return (
    <div className="pnrAppDwnldSection">
      <div className="pnrAppDwnldContent">
        <div className="pnrAppDwnldLeftSection">
          <img
            src={`${PUBLIC_URL}/static/public/appDownload_qr.webp`}
            className="desktopShow pnrAppDwnldQrIcon"
            alt={'appDownloadQr'}
          />
          <div className="pnrAppDwnldInfoSection">
            <div className="pnrAppDwnldHeading">{PNR_APP_DOWNLOAD_SECTION_CONSTANTS.heading}</div>
            <div className="pnrAppDwnldSubHeading">{PNR_APP_DOWNLOAD_SECTION_CONSTANTS.subHeading}</div>
            <div className="pnrAppDwnldIconContainer">
              <img
                src={`${PUBLIC_URL}/static/public/playStore.webp`}
                className="pnrAppDwnldIcons"
                onClick={onAppDownloadClick}
              />
              <img
                src={`${PUBLIC_URL}/static/public/appStore.webp`}
                className="pnrAppDwnldIcons"
                onClick={onAppDownloadClick}
              />
            </div>
          </div>
        </div>
        <div className="pnrAppDwnldRightSection">
          {PNR_APP_DOWNLOAD_SECTION_CONSTANTS.appStoreData?.map((data) => {
            return <AppStoreSection data={data} />;
          })}
        </div>
      </div>
    </div>
  );
}

const AppStoreSection = ({ data }: AppStoreData) => {
  return (
    <div className="pnrAppDnld_appStoreContainer" onClick={onAppDownloadClick}>
      <p className="pnrAppDnld_appStoreContainer heading desktopShow">{data.heading}</p>
      <div className="makeFlex">
        {Array.from({ length: 5 }, (_, index) => {
          const isYellowStar = data.rating >= index + 1;
          return (
            <>
              {isYellowStar ? (
                <img
                  src={`${PUBLIC_URL}/static/public/ic_yellow_star.webp`}
                  className="pnrAppDnld_appStoreRating_icon"
                />
              ) : (
                <img src={`${PUBLIC_URL}/static/public/ic_grey_star.webp`} className="pnrAppDnld_appStoreRating_icon" />
              )}
            </>
          );
        })}
        <p className="pnrAppDnld_appStoreRating_ratingText">{data.rating}</p>
      </div>
      <p className="pnrAppDnld_appStoreContainer reviewText">{data.reviewCountText}</p>
    </div>
  );
};
